import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Col, FormGroup, Input, Label, Row, } from "reactstrap";
import { useHistory } from "react-router-dom";
import { C_Button } from "../../components/Common/CommonButton";
import * as _cfunc from "../../components/Common/CommonFunction";
import { mode, pageId } from "../../routes/index"
import { MetaTags } from "react-meta-tags";
import { commonPageField, commonPageFieldSuccess, Get_Items_Drop_Down, getpdfReportdata, } from "../../store/actions";
import { C_DatePicker, C_Select } from "../../CustomValidateForm";
import C_Report from "../../components/Common/C_Report";
import { getCommonPartyDrodownOptionAction } from "../../store/Utilites/PartyDrodown/action";
import { PartyWiseItemSaleReport_GoButton_API_Success } from "../../store/Report/PartywiseItemSaleRedux/action";
import { ItemSaleReport_GoBtn_API } from "../../helpers/backend_helper";
import * as report from '../../Reports/ReportIndex'
import { allLabelWithZero } from "../../components/Common/CommonErrorMsg/HarderCodeData";
import { customAlert } from "../../CustomAlert/ConfirmDialog";

const AnnualItemSaleReport = (props) => {

    const dispatch = useDispatch();
    const history = useHistory();
    const currentDate_ymd = _cfunc.date_ymd_func();
    const [Item, setItem] = useState([allLabelWithZero]);

    const SelectedMonth = () =>
        _cfunc.getPreviousMonthAndYear({ date: new Date(), Privious: 0 });

    const FirstAndLastDate = (month) =>
        _cfunc.getFirstAndLastDateOfMonth(month);

    const [fromMonth, setFromMonth] = useState(SelectedMonth());
    const [toMonth, setToMonth] = useState(SelectedMonth());

    const firstLast = FirstAndLastDate(fromMonth);

    const [fromDate, setFromDate] = useState(firstLast.firstDate);
    const [toDate, setToDate] = useState(firstLast.lastDate);



    const [userPageAccessState, setUserAccState] = useState('');
    const location = { ...history.location }
    const hasShowModal = props.hasOwnProperty(mode.editValue)


    const {
        userAccess,
        ItemDropDown,
        commonPartyDropSelect,
        ItemDropDownloading,
        printBtnLoading

    } = useSelector((state) => ({
        GoButtonData: state.PartyWiseItemSaleReportReducer.ItemConsumption,
        ItemDropDownloading: state.StockEntryReducer.ItemDropDownloading,
        ItemDropDown: state.StockEntryReducer.ItemDropDown,
        printBtnLoading: state.PdfReportReducers.printAllBtnLoading,
        commonPartyDropSelect: state.CommonPartyDropdownReducer,
        userAccess: state.Login.RoleAccessUpdateData,
        pageField: state.CommonPageFieldReducer.pageField

    }));


    useEffect(() => {
        dispatch(commonPageFieldSuccess(null));
        dispatch(commonPageField(pageId.ANNUAL_ITEM_SALE_REPORT));
        dispatch(getCommonPartyDrodownOptionAction())

        return () => {
            dispatch(commonPageFieldSuccess(null));

        }
    }, []);

    // userAccess useEffect
    useEffect(() => {
        let userAcc = null;
        let locationPath = location.pathname;
        if (hasShowModal) {
            locationPath = props.masterPath;
        };
        userAcc = userAccess.find((inx) => {
            return (`/${inx.ActualPagePath}` === locationPath)
        })
        if (userAcc) {
            setUserAccState(userAcc)
            _cfunc.breadcrumbReturnFunc({ dispatch, userAcc });
        };
    }, [userAccess])



    useEffect(() => {
        if (commonPartyDropSelect.value > 0) {

        } else {
            partySelectOnChangeHandler();
        }
    }, [commonPartyDropSelect]);

    function partySelectOnChangeHandler() {
        PartyWiseItemSaleReport_GoButton_API_Success([]);

    }
    const ItemList_Options = ItemDropDown.map((index) => ({
        value: index.Item,
        label: index.ItemName,
    }));

    ItemList_Options.unshift(allLabelWithZero)


    useEffect(() => {
        dispatch(Get_Items_Drop_Down({
            jsonBody: JSON.stringify({
                UserID: _cfunc.loginUserID(),
                RoleID: _cfunc.loginRoleID(),
                CompanyID: _cfunc.loginCompanyID(),
                IsSCMCompany: _cfunc.loginIsSCMCompany(),
                CompanyGroup: _cfunc.loginCompanyGroup(),
                PartyID: _cfunc.loginSelectedPartyID(),

            })
        }));
    }, []);


    function goButtonHandler(goBtnMode) {

        // ✅ month range validation
        const monthDiff = getMonthDifference(fromMonth, toMonth);

        if (monthDiff > 12) {
            customAlert({
                Type: 3,   // error type (tumcha project madhe error type)
                Message: "Maximum 12 months range allowed only.",
            });
            return;
        }

        if (monthDiff <= 0) {
            customAlert({
                Type: 3,
                Message: "To Month must be greater than From Month.",
            });
            return;
        }
        try {
            const jsonBody = JSON.stringify({
                FromDate: fromDate,
                ToDate: toDate,
                PartyType: _cfunc.loginPartyTypeID(),
                Party: _cfunc.loginSelectedPartyID(),
                Employee: _cfunc.loginEmployeeID(),
                ItemID: (Item[0].value === 0) ? ItemList_Options
                    .filter(inx => inx.value !== 0)
                    .map(inx => inx.value)
                    .join(',') : Item.map(inx => inx.value).join(','),
                CompanyID: _cfunc.loginCompanyID()

            });
            const config = {
                jsonBody,
                goBtnMode,
                ReportType: report.Annual_Item_Sale_Report
            };
            dispatch(getpdfReportdata(ItemSaleReport_GoBtn_API, config))
        } catch (error) { _cfunc.CommonConsole(error) }
    }



    function fromMonthOnChange(e) {
        const selectedMonth = e.target.value;

        const { firstDate } =
            _cfunc.getFirstAndLastDateOfMonth(selectedMonth);

        setFromMonth(selectedMonth);
        setFromDate(firstDate);

        dispatch(PartyWiseItemSaleReport_GoButton_API_Success([]));
    }

    function toMonthOnChange(e) {
        const selectedMonth = e.target.value;

        const { lastDate } =
            _cfunc.getFirstAndLastDateOfMonth(selectedMonth);

        setToMonth(selectedMonth);
        setToDate(lastDate);

        dispatch(PartyWiseItemSaleReport_GoButton_API_Success([]));
    }

    // max 12 months validation helper
    function getMonthDifference(from, to) {
        const fromDate = new Date(from);
        const toDate = new Date(to);

        return (
            (toDate.getFullYear() - fromDate.getFullYear()) * 12 +
            (toDate.getMonth() - fromDate.getMonth()) + 1
        );
    }



    return (
        <React.Fragment>
            <MetaTags>{_cfunc.metaTagLabel(userPageAccessState)}</MetaTags>
            <div className="page-content">

                <div className="px-2   c_card_filter text-black " >
                    <Row className="mb-3">
                        <Col sm={3} className="">
                            <FormGroup className=" row mt-2  " >
                                <Label className="col-sm-4 p-2"
                                    style={{ width: "83px" }}>FromMonth</Label>
                                <Col sm="7">
                                    <Input
                                        type="month"
                                        value={fromMonth}
                                        className="form-control"
                                        onChange={fromMonthOnChange}
                                    />

                                </Col>
                            </FormGroup>
                        </Col>

                        <Col sm={3} className="">
                            <FormGroup className=" row mt-2 " >
                                <Label className="col-sm-4 p-2"
                                    style={{ width: "65px" }}>ToMonth</Label>
                                <Col sm="7">
                                    <Input
                                        type="month"
                                        value={toMonth}
                                        className="form-control"
                                        onChange={toMonthOnChange}
                                    />

                                </Col>
                            </FormGroup>
                        </Col>

                        <Col sm={3} className="">
                            <FormGroup className=" row mt-2" >
                                <Label className="col-sm-4 p-2"
                                    style={{ width: "65px", marginRight: "20px" }}>Item</Label>
                                <Col sm="8">
                                    <C_Select
                                        id="ItemName "
                                        name="ItemName"
                                        value={Item}
                                        isSearchable={true}
                                        isMulti={true}
                                        isLoading={ItemDropDownloading}
                                        className="react-dropdown"
                                        classNamePrefix="dropdown"
                                        styles={{
                                            menu: provided => ({ ...provided, zIndex: 2 })
                                        }}
                                        options={ItemList_Options}
                                        onChange={(e) => { setItem(e) }}
                                    />
                                </Col>
                            </FormGroup>
                        </Col>


                        <Col sm={3} className=" d-flex justify-content-end" >

                            <C_Button
                                type="button"
                                spinnerColor="white"
                                loading={printBtnLoading}
                                className="btn btn-success m-3 mr"
                                onClick={() => goButtonHandler("Print")}
                            >
                                Print
                            </C_Button>
                        </Col>
                    </Row>
                </div>
            </div>
            <C_Report />
        </React.Fragment >

    )
}


export default AnnualItemSaleReport;


// redux file use party wise item sale report not create separate file for annual item sale report because both are same report only difference is in api and pdf generation so we can use same redux file for both report.